import {get} from 'lodash';

export default (state = {}, {type, stateName, stateValue}: any) => {
  return {
    ...state,
    allClientJourneyState: {
      ...get(state, 'allClientJourneyState', {}),
      [type]: {
        [stateName]: stateValue,
      },
    },
  };
};
